// extracted by mini-css-extract-plugin
export var parcelRow = "_rz-0";